/** Canonical Canvas node Select — portals outside node overflow clipping
 * and re-syncs popup position on React Flow pan/zoom while open
 * (TASK-00050). All node-owned Select dropdowns should use this instead
 * of importing `Select` directly from `antd`. */
import { Select, type SelectProps } from 'antd'
import { useState } from 'react'
import { useCanvasAnchoredOverlayOpen } from './canvasAnchoredOverlay'

export type CanvasSelectProps = SelectProps

export default function CanvasSelect({
  open: openProp,
  defaultOpen,
  onOpenChange,
  getPopupContainer,
  popupMatchSelectWidth,
  ...rest
}: CanvasSelectProps) {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(Boolean(defaultOpen))
  const open = openProp ?? uncontrolledOpen

  useCanvasAnchoredOverlayOpen(Boolean(open))

  const handleOpenChange: NonNullable<SelectProps['onOpenChange']> = (nextOpen, ...args) => {
    onOpenChange?.(nextOpen, ...args)
    if (openProp === undefined) setUncontrolledOpen(nextOpen)
  }

  return (
    <Select
      {...rest}
      {...(openProp !== undefined ? { open: openProp } : {})}
      defaultOpen={defaultOpen}
      onOpenChange={handleOpenChange}
      popupMatchSelectWidth={popupMatchSelectWidth ?? false}
      getPopupContainer={getPopupContainer ?? (() => document.body)}
    />
  )
}
